// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/turn-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/turn-technique/turn-technique.js';

mount([g0]);
